import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import { ActionButtons, SectionHeader } from '../../common/components';
import { CreateBooking, saveBookingAsync } from './bookingsSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getAccommodationDetailsAsync,
  selectAccommodationDetails,
} from '../accommodations/accommodationsSlice';

function AddBooking() {
  const backLinkUrl = '/bookings/search-bookings';
  const dispatch = useAppDispatch();
  const accommodationDetails = useAppSelector(selectAccommodationDetails);
  const [searchParams] = useSearchParams();
  const selectedAccommodationId = searchParams.get('accommodationId');

  const initialBookingState: CreateBooking = {
    bookingNumber: 0,
    payerId: '00000000-0000-0000-0000-000000000000',
    accommodationId: '00000000-0000-0000-0000-000000000000',
    arrivalDateTime: '',
    departureDateTime: '',
    customerBookingNote: {
      noteText: '',
    },
    ownerBookingNote: {
      noteText: '',
    },
    officerBookingNote: {
      noteText: '',
    },
  };

  const [booking, setBooking] = useState(initialBookingState);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(getAccommodationDetailsAsync(selectedAccommodationId));
    setBooking({
      ...booking,
      accommodationId: selectedAccommodationId,
    });
  }, [searchParams]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newBooking = { ...booking };
    let pointer = newBooking;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setBooking(newBooking);
  };

  const addBooking = () => {
    dispatch(saveBookingAsync(booking));
    setSubmitted(true);
  };

  return (
    <>
      <Helmet>
        <title>Varaukset - Uusi varaus</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Varaukset']}
          Title="Uusi varaus"
        />

        <Container className="container-form mt-48">
          <Form.Group controlId="bookingNumber" className="mb-40">
            <Form.Label className="required">Varauksen tunniste</Form.Label>
            <Form.Control
              autoComplete="off"
              required
              value={booking.bookingNumber || ''}
              onChange={handleInputChange}
              name="bookingNumber"
            />
          </Form.Group>

          <Form.Group className="mb-40">
            <Form.Label>Kohde</Form.Label>
            <p className="mb-0">{accommodationDetails?.accommodationNumber}</p>
          </Form.Group>

          <Row xs={1} sm={2}>
            <Col>
              <Form.Group controlId="arrivalDateTime" className="mb-40">
                <Form.Label className="required">Varaus alkaa</Form.Label>
                <Form.Control
                  type="datetime-local"
                  autoComplete="off"
                  required
                  value={booking.arrivalDateTime || ''}
                  onChange={handleInputChange}
                  name="arrivalDateTime"
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="departureDateTime" className="mb-40">
                <Form.Label className="required">Varaus päättyy</Form.Label>
                <Form.Control
                  type="datetime-local"
                  autoComplete="off"
                  required
                  value={booking.departureDateTime || ''}
                  onChange={handleInputChange}
                  name="departureDateTime"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="customerBookingNoteText" className="mb-40">
            <Form.Label>Lisätiedot asiakkaalle ja laskulle</Form.Label>
            <Form.Control
              as="textarea"
              value={booking.customerBookingNote.noteText || ''}
              onChange={handleInputChange}
              name="customerBookingNote.noteText"
            />
          </Form.Group>

          <Form.Group controlId="ownerBookingNoteText" className="mb-40">
            <Form.Label>Lisätiedot omistajalle</Form.Label>
            <Form.Control
              as="textarea"
              value={booking.ownerBookingNote.noteText || ''}
              onChange={handleInputChange}
              name="ownerBookingNote.noteText"
            />
          </Form.Group>

          <Form.Group controlId="officerBookingNoteText" className="mb-40">
            <Form.Label>Lisätiedot virkailijoille</Form.Label>
            <Form.Control
              as="textarea"
              value={booking.officerBookingNote.noteText || ''}
              onChange={handleInputChange}
              name="officerBookingNote.noteText"
            />
          </Form.Group>

          <ActionButtons
            CancelButtonUrl={backLinkUrl}
            HandleSave={addBooking}
          />
          {submitted && <Alert variant="success">Tiedot tallennettu!</Alert>}
        </Container>
      </Container>
    </>
  );
}

export default AddBooking;
